module.exports = __webpack_public_path__ + "static/media/documents.58fa2572.svg";